import React, {useEffect, useState} from "react";

export default function Copyright() {
    const [year, setYear] = useState(null);

    useEffect(() => {
        const d = new Date();
        setYear(d.getFullYear());
    }, []);


    return (
        <>
            {year && <div className="col-12 d-flex flex-column align-items-center small text-center">
                <div>Copyright © { year }<br/>Todos os direitos reservados.</div>
            </div>}
        </>
    );
}